import {
  Validators,
  FormBuilder,
  FormGroup,
  AbstractControl,
} from '@angular/forms';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { DialogYesNoComponent } from '../components/dialog-yes-no/dialog-yes-no.component';

import { AppInjector } from 'src/app/core/services/app-injector.service';

import { MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { Basei18n } from './base-i18n';

declare var $: any;

export class BaseManagement extends Basei18n {
  id: any;
  statusId: any;
  workflowId: any;
  isNew: boolean = false;
  form: any;
  serverError: any = '';

  saving: {
    isSaving: boolean;
    action: any;
  };

  protected dialog: MatDialog;
  protected translate: TranslateService;

  constructor() {
    super();

    this.dialog = AppInjector.injector.get(MatDialog);
    this.translate = AppInjector.injector.get(TranslateService);

    this.saving = {
      isSaving: false,
      action: '',
    };
  }

  isSaving() {
    return this.saving.isSaving;
  }

  startSaving(action) {
    this.saving = {
      isSaving: true,
      action: action,
    };
  }

  stopSaving() {
    this.saving = {
      isSaving: false,
      action: '',
    };
  }

  canDeactivate(): Observable<boolean> | boolean {
    var formValidates = false;
    if (this.form) {
      formValidates = this.form.dirty ? true : false;
    }

    if (!this.saving.isSaving && formValidates) {
      this.translate
        .get(['message.dialogLeave', 'message.yes', 'message.no'])
        .subscribe((translations) => {
          let dialogRef = this.dialog.open(DialogYesNoComponent, {
            width: '250px',
            data: {
              msg: translations['message.dialogLeave'],
              yesText: translations['message.yes'],
              noText: translations['message.no'],
            },
          });

          dialogRef.afterClosed().subscribe((result) => {
            if (result == 1) {
              return true;
            } else {
              return false;
            }
          });
        });
    } else {
      console.log('Returns: true');

      return true;
    }
  }

  selectionChange(e) {
    setTimeout(() => {
      this.scrollToSectionHook(e.selectedIndex);
    }, 800);
  }

  scrollToSectionHook(index) {
    const element = $('.stepperTop' + index)
      .parents('mat-step-header')
      .get(0);

    if (element) {
      $('.stepperTop' + index)
        .parents('.container.ps')
        .animate({
          scrollTop: $(element).position().top + 70,
        });
    }
  }

  setRequired(form, controls, isRequired) {
    controls.forEach((control) => {
      if (isRequired) {
        form.get(control).setValidators([Validators.required]);
      } else {
        form.get(control).clearValidators();
      }

      form.get(control).updateValueAndValidity();
    });
  }
}
